import React from 'react';

const UNIDADES_FORNECIMENTO = [
  'UN', 'CX', 'PCT', 'FD', 'DZ', 'PAR', 'KG', 'G', 'L', 'ML', 'M', 'M2', 'M3', 'SC', 'TB', 'GL', 'FR', 'PT', 'RL', 'VD',
];

function ListaCompraModal({ show, onClose, onSubmit, form, setForm, itens, setItens, programas = [], acoes = [] }) {
  if (!show) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleProgramaChange = (e) => {
    const idPrograma = e.target.value;
    setForm(prev => ({ ...prev, idPrograma, idAcao: '' }));
  };

  const acoesDisponiveis = acoes.filter(a => String(a.idPrograma) === String(form.idPrograma));

  const handleItemChange = (index, field, value) => {
    setItens(prev => prev.map((item, i) => (i === index ? { ...item, [field]: value } : item)));
  };

  const handleAddItem = () => {
    setItens(prev => [...prev, { descricao: '', tipo: 'CUSTEIO', unidade: 'UN', quantidade: '', valorUnitario: '' }]);
  };

  const handleRemoveItem = (index) => {
    setItens(prev => prev.filter((_, i) => i !== index));
  };

  /**
   * Converte valor digitado em número, aceitando os dois formatos:
   *  - "1.200,50" -> 1200.5  (vírgula decimal, ponto de milhar)
   *  - "1200.50"  -> 1200.5  (ponto decimal, formato ISO vindo de input)
   */
  const parseFloatBR = (valor) => {
    if (valor === null || valor === undefined || valor === '') return 0;
    const s = String(valor).trim();
    if (s === '') return 0;
    const normalizado = s.includes(',')
      ? s.replace(/\./g, '').replace(',', '.')
      : s;
    const numero = parseFloat(normalizado);
    return Number.isNaN(numero) ? 0 : numero;
  };

  /** Normaliza o valor digitado para o formato com ponto decimal (padrão de envio). */
  const onChangeNumerico = (index, campo) => (e) => {
    const bruto = e.target.value.replace(/[^0-9.,]/g, '');
    handleItemChange(index, campo, bruto);
  };

  const formatBR = (valor) =>
    valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const totalItem = (item) => {
    const qtd = parseFloatBR(item.quantidade);
    const unit = parseFloatBR(item.valorUnitario);
    return formatBR(qtd * unit);
  };

  const totalGeral = itens.reduce((acc, item) => acc + parseFloatBR(item.quantidade) * parseFloatBR(item.valorUnitario), 0);

  const subtotalPorTipo = (tipo) =>
    formatBR(
      itens
        .filter(item => (item.tipo || 'CUSTEIO') === tipo)
        .reduce((acc, item) => acc + parseFloatBR(item.quantidade) * parseFloatBR(item.valorUnitario), 0)
    );

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.data) {
      alert('Preencha a data da lista');
      return;
    }
    if (!form.hora) {
      alert('Preencha a hora da lista');
      return;
    }
    const itensValidos = itens.filter(item => item.descricao && item.descricao.trim());
    if (itensValidos.length === 0) {
      alert('Adicione ao menos um item à lista');
      return;
    }
    for (const item of itensValidos) {
      const qtd = parseFloatBR(item.quantidade);
      const unit = parseFloatBR(item.valorUnitario);
      if (qtd <= 0) {
        alert(`Informe a quantidade do item "${item.descricao}"`);
        return;
      }
      if (unit < 0) {
        alert(`Informe o valor unitário do item "${item.descricao}"`);
        return;
      }
    }
    onSubmit({
      id: form.id,
      data: form.data,
      hora: form.hora,
      idPrograma: form.idPrograma ? Number(form.idPrograma) : null,
      idAcao: form.idAcao ? Number(form.idAcao) : null,
      itens: itensValidos.map(item => ({
        descricao: item.descricao.trim(),
        tipo: item.tipo === 'CAPITAL' ? 'CAPITAL' : 'CUSTEIO',
        unidade: (item.unidade || 'UN').trim().toUpperCase(),
        quantidade: parseFloatBR(item.quantidade),
        valorUnitario: parseFloatBR(item.valorUnitario),
      })),
    });
  };

  return (
    <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1055 }}>
      <div
        className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
        style={{ width: '90vw', maxWidth: '90vw', height: '90vh', minHeight: '90vh', maxHeight: '90vh' }}
      >
        <form
          className="modal-content"
          onSubmit={handleSubmit}
          style={{ height: '90vh', maxHeight: '90vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}
        >
          <div className="modal-header bg-success text-white py-1 px-2">
            <h6 className="modal-title small">{form.id ? 'Editar Lista de Compras' : 'Cadastro de Lista de Compras'}</h6>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          <div className="modal-body">
              <datalist id="unidades-fornecimento">
                {UNIDADES_FORNECIMENTO.map(u => (
                  <option key={u} value={u} />
                ))}
              </datalist>
              <div className="mb-3" style={{ display: 'grid', gridTemplateColumns: '35% 35% 15% 15%', alignItems: 'start' }}>
                <div className="pe-2 d-flex flex-column" style={{ minWidth: 0, rowGap: '.35rem' }}>
                  <label className="form-label mb-0" style={{ lineHeight: 1.2 }}>Programa</label>
                  <select
                    name="idPrograma"
                    className="form-select form-select-sm"
                    value={form.idPrograma || ''}
                    onChange={handleProgramaChange}
                  >
                    <option value="">Selecione...</option>
                    {programas.map(p => (
                      <option key={p.id} value={String(p.id)}>{p.descricao}</option>
                    ))}
                  </select>
                </div>
                <div className="pe-2 d-flex flex-column" style={{ minWidth: 0, rowGap: '.35rem' }}>
                  <label className="form-label mb-0" style={{ lineHeight: 1.2 }}>Ação</label>
                  <select
                    name="idAcao"
                    className="form-select form-select-sm"
                    value={form.idAcao || ''}
                    onChange={handleChange}
                    disabled={!form.idPrograma}
                  >
                    <option value="">{form.idPrograma ? 'Selecione...' : 'Selecione um programa'}</option>
                    {acoesDisponiveis.map(a => (
                      <option key={a.id} value={String(a.id)}>{a.descricao}</option>
                    ))}
                  </select>
                </div>
                <div className="pe-2 d-flex flex-column" style={{ minWidth: 0, rowGap: '.35rem' }}>
                  <label className="form-label text-nowrap mb-0" style={{ lineHeight: 1.2 }}>Data *</label>
                  <input
                    type="date"
                    name="data"
                    className="form-control form-control-sm"
                    style={{ minWidth: 0 }}
                    value={form.data || ''}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="d-flex flex-column" style={{ minWidth: 0, rowGap: '.35rem' }}>
                  <label className="form-label text-nowrap mb-0" style={{ lineHeight: 1.2 }}>Hora *</label>
                  <input
                    type="time"
                    name="hora"
                    className="form-control form-control-sm"
                    style={{ minWidth: 0 }}
                    value={form.hora || ''}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <label className="form-label fw-bold">Itens *</label>
              <div className="table-responsive">
                <table className="table table-sm table-bordered align-middle">
                  <thead className="table-light text-uppercase text-center align-middle" style={{ fontSize: '.7rem', letterSpacing: '.03em' }}>
                    <tr>
                      <th className="fw-semibold text-secondary text-center align-middle" style={{ width: '27%' }}>Item / Descrição</th>
                      <th className="fw-semibold text-secondary text-center align-middle" style={{ width: '12%' }}>Tipo</th>
                      <th className="fw-semibold text-secondary text-center align-middle" style={{ width: '10%' }}>Unid.</th>
                      <th className="fw-semibold text-secondary text-center align-middle" style={{ width: '12%' }}>Qtd Estimada</th>
                      <th className="fw-semibold text-secondary text-center align-middle" style={{ width: '16%' }}>Valor Unit. Estimado (R$)</th>
                      <th className="fw-semibold text-secondary text-center align-middle" style={{ width: '14%' }}>Total (R$)</th>
                      <th className="fw-semibold text-secondary text-center align-middle" style={{ width: '9%' }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {itens.map((item, index) => (
                      <tr key={index}>
                        <td>
                          <input
                            type="text"
                            className="form-control form-control-sm"
                            value={item.descricao}
                            onChange={(e) => handleItemChange(index, 'descricao', e.target.value)}
                            placeholder="Descrição do item"
                          />
                        </td>
                        <td>
                          <select
                            className={`form-select form-select-sm ${item.tipo === 'CAPITAL' ? 'border-primary' : ''}`}
                            value={item.tipo || 'CUSTEIO'}
                            onChange={(e) => handleItemChange(index, 'tipo', e.target.value)}
                          >
                            <option value="CUSTEIO">Custeio</option>
                            <option value="CAPITAL">Capital</option>
                          </select>
                        </td>
                        <td>
                          <input
                            type="text"
                            className="form-control form-control-sm text-uppercase"
                            list="unidades-fornecimento"
                            value={item.unidade || ''}
                            onChange={(e) => handleItemChange(index, 'unidade', e.target.value)}
                            placeholder="UN"
                            maxLength="20"
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            inputMode="decimal"
                            className="form-control form-control-sm text-end"
                            value={item.quantidade}
                            onChange={onChangeNumerico(index, 'quantidade')}
                            placeholder="0"
                          />
                        </td>
                        <td>
                          <input
                            type="text"
                            inputMode="decimal"
                            className="form-control form-control-sm text-end"
                            value={item.valorUnitario}
                            onChange={onChangeNumerico(index, 'valorUnitario')}
                            placeholder="0,00"
                          />
                        </td>
                        <td className="text-end">{totalItem(item)}</td>
                        <td className="text-center">
                          <button
                            type="button"
                            className="btn btn-outline-danger btn-sm"
                            title="Remover item"
                            onClick={() => handleRemoveItem(index)}
                          >
                            <i className="bi bi-trash"></i>
                          </button>
                        </td>
                      </tr>
                    ))}
                    {itens.length === 0 && (
                      <tr>
                        <td colSpan="7" className="text-center text-muted small py-3">
                          Nenhum item adicionado. Clique em "Adicionar Item".
                        </td>
                      </tr>
                    )}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan="5" className="text-end">Subtotal Custeio (R$)</td>
                      <td className="text-end">{subtotalPorTipo('CUSTEIO')}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td colSpan="5" className="text-end">Subtotal Capital (R$)</td>
                      <td className="text-end">{subtotalPorTipo('CAPITAL')}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td colSpan="5" className="text-end fw-bold">Total Geral (R$)</td>
                      <td className="text-end fw-bold">{formatBR(totalGeral)}</td>
                      <td></td>
                    </tr>
                  </tfoot>
                </table>
              </div>
              <button type="button" className="btn btn-outline-success btn-sm" onClick={handleAddItem}>
                <i className="bi bi-plus-lg me-1"></i>Adicionar Item
              </button>
            </div>
            <div className="modal-footer py-1 px-2">
              <button type="button" className="btn btn-secondary btn-sm" onClick={onClose}>Cancelar</button>
              <button type="submit" className="btn btn-success btn-sm">Salvar</button>
            </div>
        </form>
      </div>
    </div>
  );
}

export default ListaCompraModal;
